import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useSiteTypesList(){

  const isSiteTypesFormSidebarActive = ref(false)
  const { t } = useI18nUtils();
  const siteTypesData = ref(null);
  const siteTypes = ref([])
  const contentsData = ref(null);
  const toast = useToast()
  const refSiteTypesListTable = ref(null);
  const tableColumns = [
      { key: 'name', label: 'type name', sortable: false },
      { key: 'is_active', label: 'Status', sortable: false },
      { key: 'action', label: '#', sortable: false },
  ]
  const perPage = ref(10)
  const totalSiteTypes = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const dataMeta = computed(() => {
    const localItemsCount = refSiteTypesListTable.value ? refSiteTypesListTable.value.localItems.length : 0
      return {
          from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
          to: perPage.value * (currentPage.value - 1) + localItemsCount,
          of: totalSiteTypes.value,
      }
  })

  const refetchData = () => {
    refSiteTypesListTable.value.refresh()
    fetchData()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchData = (ctx, callback) => {
    const offset = perPage.value*(currentPage.value-1);

    store
      .dispatch('app-sites/getSiteTypes', {
        limit: perPage.value,
        offset: offset,
        keywords: searchQuery.value
      })
      .then(response => {
        siteTypes.value  = response.data.data
        totalSiteTypes.value = response.data.total
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching Type' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    )
  }

  const updateSiteType = (data)=>{
    siteTypesData.value = {...data};
    isSiteTypesFormSidebarActive.value = true;
  }

  const resolveStatusVariant = status => {
    if (status ) return 'success'
    if (!status ) return 'secondary'
    return 'primary'
  }

  const resolveStatusnameVariant = status => {
      if (status) return 'Active'
      if (!status) return 'Inactive'
      return 'primary'
  }

  const deleteData = (id) => {
    store.dispatch('app-sites/deleteSiteType',id).then(response=>{
      toast({
        component: ToastificationContent,
        props: {
          title: "Delete Success",
          icon: 'AlertTriangleIcon',
          variant: 'success',
        },
      })
      fetchData();
    }).catch(()=>{
      toast({
        component: ToastificationContent,
        props: {
          title: "Error Delete Blog",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })

    })
  }

  return {
    isSiteTypesFormSidebarActive,
    refSiteTypesListTable,
    siteTypesData,
    tableColumns,
    perPage,
    totalSiteTypes,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    refetchData,
    fetchData,
    updateSiteType,
    deleteData,
    totalSiteTypes,
    siteTypes,
    t,
    contentsData,
    statusFilter,
    resolveStatusVariant,
    resolveStatusnameVariant,
  }
}